/**
 * Modal window directive for Edit Virtual Live
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 06.03.2015-19:23
 */

lmApp.directive('lmVirtualLiveEdit', [function () {
  return {
    restrict: 'E',
    replace: true,
    controller: 'LmVirtualLiveController',
    templateUrl: 'lm-assets-edit/virtual-live/edit-virtual-live.tpl.html'
  };
}]);

lmApp
  .controller('LmVirtualLiveController', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', '$interval', 'MetadataService', 'AssetService', 'ToastService', 'GroupService', 'PackageService', 'ManageAssetsWindow', 'VirtualLiveApiService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, $interval, MetadataService, AssetService, ToastService, GroupService, PackageService, ManageAssetsWindow, VirtualLiveApiService) {

      $scope.playlistManager = function (asset) {
        if ($scope.$parent.loading) return;

        ManageAssetsWindow.OpenManageAssetsWindow({
          manageAssetsFn: function (toAdd, toRemove, toThis) {
            if ($scope.loading) return;

            if (toRemove.length) {
              var index;
              for (var i = 0; i < toRemove.length; i++) {
                index = _.findIndex(toThis._PrivateData.playlist, {id: toRemove[i].id});

                if (index !== -1) {
                  toThis._PrivateData.playlist.splice(index, 1);
                }
              }
            }

            if (toAdd.length) {
              toThis._PrivateData.playlist = _.union(toThis._PrivateData.playlist, toAdd);
            }

            return $q.when(true);
          },
          obj: asset,
          index: asset._PrivateData.index,
          data: 'playlist',
          title: asset.title,
          currentCollection: _.map(asset._PrivateData.playlist, 'id'),
          view: 'vod',
          filter: {
            packages: true
          }
        })
      };

      /**
       * TODO: SCOPES!!!!!
       *
       * Allow to Edit next asset in collection (if not Last)
       */
      $scope.$parent.nextAsset = function () {
        if ($scope.$parent.loading) return;

        if ($scope.$parent.currentFocused < $scope.localCollection.length - 1) {
          $scope.$parent.currentFocused++;
          $scope.localCollection[$scope.$parent.currentFocused]._PrivateData = {};
          $scope.asset = $scope.localCollection[$scope.$parent.currentFocused];
          $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
        }
      };

      /**
       * TODO: SCOPES!!!!
       *
       * Allow ti Edit previous asset in collection (if not First)
       */
      $scope.$parent.previousAsset = function () {
        if ($scope.$parent.loading) return;

        if ($scope.$parent.currentFocused > 0) {
          $scope.$parent.currentFocused--;
          $scope.localCollection[$scope.$parent.currentFocused]._PrivateData = {};
          $scope.asset = $scope.localCollection[$scope.$parent.currentFocused];
          $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
        }
      };

      $scope.removeFromRotation = function (assetData) {
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().subtract(1, 'day');
      };

      $scope.setOneMonthRotation = function (assetData) {
        assetData._PrivateData.rentalNew.license_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.license_finish = moment.utc().add(1, 'month');
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().add(1, 'month');
      };

      $scope.setOneYearRotation = function (assetData) {
        assetData._PrivateData.rentalNew.license_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.license_finish = moment.utc().add(1, 'year');
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().add(1, 'year');
      };

      /**
       * Prepare asset for Edit. Add '_PrivateData' filed with parsed metadata
       * @param assetData
       * @returns {*}
       */
      $scope.prepareAssetForEdit = function (assetData) {

        assetData._PrivateData.qualityFormats = [
          {
            title: 'HD',
            isSelected: false
          },
          {
            title: 'SD',
            isSelected: false
          }
        ];

        assetData._PrivateData.adultContent = assetData.has_adult_content;

        assetData._PrivateData.rentalOld = MetadataService.Rental.GetValues(assetData);
        assetData._PrivateData.rentalNew = angular.copy(assetData._PrivateData.rentalOld);

        assetData._PrivateData.genresOld = assetData.genres.map(function (genre) {
          return {
            title: genre.title,
            id: genre.id
          }
        });
        assetData._PrivateData.genresNew = angular.copy(assetData._PrivateData.genresOld);
        AssetService.GetGenresCollection()
          .then(function (answer) {
            $scope.genreSearch = answer.map(function (genre) {
              return {
                title: genre.title,
                id: genre.id
              }
            });
          })
          .catch(function (reason) {
            $scope.genreSearch = [];
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        assetData._PrivateData.categoriesOld = assetData.categories.map(function (item) {
          return {
            title: item.title,
            id: item.id
          };
        });

        assetData._PrivateData.categoriesNew = angular.copy(assetData._PrivateData.categoriesOld);
        AssetService.GetCategoryCollection()
          .then(function (answer) {
            $scope.categorySearch = answer.map(function (category) {
              return {
                title: category.title,
                id: category.id
              }
            });
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });

        GroupService.GetGroups()
          .then(function (collection) {
            $scope.groupSearch = collection.map(function (group) {
              return {
                title: group.name,
                id: group.id
              }
            });

            assetData._PrivateData.groupsOld = collection
              .filter(function (group) {
                return _.includes(assetData.group_id, group.id);
              })
              .map(function (group) {
                return {
                  title: group.name,
                  id: group.id
                }
              });
            assetData._PrivateData.groupsNew = angular.copy(assetData._PrivateData.groupsOld);
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        PackageService.GetPackages()
          .then(function (collection) {
            $scope.packageSearch = collection.map(function (pkg) {
              return {
                title: pkg.title,
                id: pkg.id
              }
            });

            assetData._PrivateData.packagesOld = collection
              .filter(function (pkg) {
                return _.includes(assetData.package_id, pkg.id);
              })
              .map(function (pkg) {
                return {
                  title: pkg.title,
                  id: pkg.id
                }
              });
            assetData._PrivateData.packagesNew = angular.copy(assetData._PrivateData.packagesOld);
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        var pictureResources = assetData.resources && assetData.resources.filter(function (resourse) {
            return resourse.category === 'poster_blueprint';
          });

        if (pictureResources && pictureResources.length) {
          AssetService.GetPoster(assetData)
            .then(function (answer) {
              assetData._PrivateData.posterUrl = answer;
            });

          assetData._PrivateData.posterResourceId = pictureResources[0].id;
          assetData._PrivateData.posterOld = pictureResources[0].source;
          assetData._PrivateData.posterNew = assetData._PrivateData.posterOld;
        } else {
          assetData._PrivateData.posterOld = '';
          assetData._PrivateData.posterNew = '';
        }

        assetData._PrivateData.platformsOld = MetadataService.Platforms.GetAvailablePlatforms(assetData, $rootScope.platforms);
        assetData._PrivateData.platformsNew = angular.copy(assetData._PrivateData.platformsOld);

        if (_.size(assetData._playlist)) {
          assetData._PrivateData.playlist = assetData._playlist;

          assetData._PrivateData.start = {
            date: moment.utc((assetData._playlist.start || moment().unix()) * 1000),
            time: moment.utc((assetData._playlist.start || moment().unix()) * 1000).diff(moment.utc((assetData._playlist.start || moment().unix()) * 1000).startOf('day'), 'seconds')
          };
        } else if (assetData.id) {
          VirtualLiveApiService.GetPlaylist(assetData.id)
            .then(function (playlist) {
              assetData._PrivateData.playlist = playlist || [];
              assetData._PrivateData.start = {
                date: moment.utc((playlist.start || moment().unix()) * 1000),
                time: moment.utc((playlist.start || moment().unix()) * 1000).diff(moment.utc((playlist.start || moment().unix()) * 1000).startOf('day'), 'seconds')
              };
            });
        }

        assetData._PrivateData.qualityFormat = assetData.traits[0];

        return assetData;
      };

      /**
       * Get current Asset data on window Open
       */
      $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
      $scope.validateFields = MetadataService.ValidateMetadata.VirtualLive;


      /**
       * @define [CREATE]
       * Defines Create function for asset
       * @param newAsset
       */
      $scope.$parent.createFn = function (newAsset) {

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        if (!_.isEmpty($scope.validateFields(newAsset))) {
          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            color: 'amber',
            title: 'Empty fields',
            text: 'Not all required fields are filled. Check all marked fields',
            icon: 'alert'
          }, 60 * 1000);
          return;
        }

        var ext_id = "personal:" + translit(newAsset.title) + ':' + CryptoJS.MD5(newAsset.title).toString(CryptoJS.enc.Hex) + ':' + guid();

        AssetService.CreateNewVirtualLive(ext_id, newAsset)
          .then(function (response) {

            var allQ = {};

            newAsset.id = response.asset.id;

            newAsset.definition = newAsset._PrivateData.qualityFormat || 'SD';
            allQ.commonMetadata = AssetService.UpdateCommonAssetMetadata.bind(this, {asset_id: newAsset.id, definition: newAsset.definition});

            allQ.adult = AssetService.SetAdult.bind(this, newAsset.id, newAsset._PrivateData.adultContent);

            if (newAsset._PrivateData.posterNew) {
              allQ.picture = AssetService.AddVodPoster.bind(this, newAsset._PrivateData.posterNew, newAsset.id);
            } else {
              allQ.picture = AssetService.AddVodPoster.bind(this, 'https://storage-sc-ott3.s3.amazonaws.com/no-channel-logo.png', newAsset.id);
            }

            var TvCategory = $scope.categorySearch.filter(function (category) {
              return category.title === 'TV';
            });

            if (TvCategory.length) newAsset._PrivateData.categoriesNew = newAsset._PrivateData.categoriesNew.concat(TvCategory);

            allQ.genres = MetadataService.Genres.Update.bind(this, [], newAsset._PrivateData.genresNew, newAsset.id);

            allQ.categories = MetadataService.Categories.Update.bind(this, [], newAsset._PrivateData.categoriesNew, newAsset.id);

            allQ.platforms = MetadataService.Platforms.Update.bind(this, [], newAsset._PrivateData.platformsNew, newAsset.id);

            allQ.rental = AssetService.UpdateRentalRotation.bind(this, newAsset._PrivateData.rentalNew, newAsset.id);

            var groupToRemove = _.difference(_.map(newAsset._PrivateData.groupsOld, 'id'), _.map(newAsset._PrivateData.groupsNew, 'id'));
            var groupToAdd = _.difference(_.map(newAsset._PrivateData.groupsNew, 'id'), _.map(newAsset._PrivateData.groupsOld, 'id'));
            if (groupToAdd.length) allQ.groupsAdd = GroupService.AddAsset.bind(this, groupToAdd, [response.asset.id]);
            if (groupToRemove.length) allQ.groupsRemove = GroupService.RemoveAsset.bind(this, groupToRemove, [response.asset.id]);

            var packageToRemove = _.difference(_.map(newAsset._PrivateData.packagesOld, 'id'), _.map(newAsset._PrivateData.packagesNew, 'id'));
            var packageToAdd = _.difference(_.map(newAsset._PrivateData.packagesNew, 'id'), _.map(newAsset._PrivateData.packagesOld, 'id'));
            if (packageToAdd.length) allQ.packagesAdd = PackageService.AddAsset.bind(this, packageToAdd, [response.asset.id]);
            if (packageToRemove.length) allQ.packagesRemove = PackageService.RemoveAsset.bind(this, packageToRemove, [response.asset.id]);

            //allQ.playlist = VirtualLiveApiService.SetPlaylist.bind(this, newAsset.id, newAsset._PrivateData.playlist.groups);
            //var startTime = newAsset._PrivateData.start.date.unix() + newAsset._PrivateData.start.time;
            //allQ.startTime = VirtualLiveApiService.SetStartTime.bind(this, newAsset.id, startTime);

            return $q.seqAll(allQ)
              .then(function () {
                $rootScope.hideLinearProgress('#modalLoader');
                $scope.$parent.loading = false;

                ToastService.Small({
                  title: 'Virtual TV Channel: <b class="tc-white">' + newAsset.title + '</b> successfully created',
                  color: 'green',
                  icon: 'cloud-check'
                }, 1000 * 6);
                $scope.close();
                $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all'});

                return true;

              }).catch(function (reason) {
                $scope.$parent.loading = false;
                $rootScope.hideLinearProgress('#modalLoader');

                ToastService.Small({
                  title: 'Virtual TV Channel: <b class="tc-white">' + newAsset.title + '</b> create failed',
                  color: 'red',
                  icon: 'cloud-outline-off'
                }, 1000 * 6);

                ToastService.Big({
                  title: 'Errors during creation',
                  color: 'red',
                  text: reason.key + ': ' + reason.error.message,
                  icon: 'cloud-outline-off'
                }, 1000 * 6 * 3);

                $rootScope.debugInfo(reason.error);

                return reason;
              });
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#modalLoader');
            $scope.$parent.loading = false;

            if (reason.message === 'item with this ext_id already exist') {

              ToastService.Small({
                title: 'Virtual TV Channel with this title already exist',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 6);
            } else {

              ToastService.Small({
                title: 'Virtual TV Channel: <b class="tc-white">' + newAsset.title + '</b> create failed',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 6);
            }

            $rootScope.debugInfo(reason);

            return reason;
          });
      };

      /**
       * @define [UPDATE]
       * Defines Update function for asset
       * @param asset
       */
      $scope.$parent.updateFn = function (asset) {

        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var allQ = {};

        if (!_.isEmpty($scope.validateFields(asset))) {
          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            color: 'amber',
            title: 'Empty fields',
            text: 'Not all required fields are filled. Check all marked fields.',
            icon: 'alert'
          }, 60 * 1000);
          return;
        }

        allQ.adult = AssetService.SetAdult.bind(this, asset.id, asset._PrivateData.adultContent);

        asset.definition = asset._PrivateData.qualityFormat || 'SD';
        allQ.metadata = AssetService.UpdateVirtualLiveMetadata.bind(this, asset);
        allQ.metadataCommon = AssetService.UpdateCommonAssetMetadata.bind(this, {asset_id: asset.id, definition: asset.definition});

        allQ.genres = MetadataService.Genres.Update.bind(this, asset._PrivateData.genresOld, asset._PrivateData.genresNew, asset.id);

        allQ.categories = MetadataService.Categories.Update.bind(this, asset._PrivateData.categoriesOld, asset._PrivateData.categoriesNew, asset.id);

        allQ.platforms = MetadataService.Platforms.Update.bind(this, asset._PrivateData.platformsOld, asset._PrivateData.platformsNew, asset.id);

        allQ.rental = AssetService.UpdateRentalRotation.bind(this, asset._PrivateData.rentalNew, asset.id);

        if (!asset._PrivateData.posterOld && asset._PrivateData.posterNew) {
          allQ.picture = AssetService.AddVodPoster.bind(this, asset._PrivateData.posterNew, asset.id);
        } else if (asset._PrivateData.posterNew !== asset._PrivateData.posterOld) {
          allQ.picture = AssetService.UpdateVodPoster.bind(this, asset.id, asset._PrivateData.posterNew, asset._PrivateData.posterResourceId);
        }

        var groupToRemove = _.difference(_.map(asset._PrivateData.groupsOld, 'id'), _.map(asset._PrivateData.groupsNew, 'id'));
        var groupToAdd = _.difference(_.map(asset._PrivateData.groupsNew, 'id'), _.map(asset._PrivateData.groupsOld, 'id'));
        if (groupToAdd.length) allQ.groupsAdd = GroupService.AddAsset.bind(this, groupToAdd, [asset.id]);
        if (groupToRemove.length) allQ.groupsRemove = GroupService.RemoveAsset.bind(this, groupToRemove, [asset.id]);

        var packageToRemove = _.difference(_.map(asset._PrivateData.packagesOld, 'id'), _.map(asset._PrivateData.packagesNew, 'id'));
        var packageToAdd = _.difference(_.map(asset._PrivateData.packagesNew, 'id'), _.map(asset._PrivateData.packagesOld, 'id'));
        if (packageToAdd.length) allQ.packagesAdd = PackageService.AddAsset.bind(this, packageToAdd, [asset.id]);
        if (packageToRemove.length) allQ.packagesRemove = PackageService.RemoveAsset.bind(this, packageToRemove, [asset.id]);

        //allQ.playlist = VirtualLiveApiService.SetPlaylist.bind(this, asset.id, asset._PrivateData.playlist.groups);
        //var startTime = asset._PrivateData.start.date.unix() + asset._PrivateData.start.time;
        //allQ.startTime = VirtualLiveApiService.SetStartTime.bind(this, asset.id, startTime);

        return $q.seqAll(allQ)
          .then(function () {
            $rootScope.hideLinearProgress('#modalLoader');
            $scope.$parent.loading = false;

            ToastService.Small({
              title: 'Virtual TV Channel: <b class="tc-white">' + asset.title + '</b> successfully updated',
              color: 'green',
              icon: 'cloud-check'
            }, 1000 * 6);

            $scope.close();
            $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
              id: asset.id
            });

            return true;
          }).catch(function (reason) {
            $rootScope.hideLinearProgress('#modalLoader');
            $scope.$parent.loading = false;

            ToastService.Small({
              title: 'Virtual TV Channel: <b class="tc-white">' + asset.title + '</b> update failed',
              color: 'red',
              icon: 'cloud-outline-off'
            }, 1000 * 6);

            ToastService.Big({
              title: 'Errors during update',
              color: 'red',
              text: reason.key + ': ' + reason.error.message,
              icon: 'cloud-outline-off'
            }, 1000 * 6 * 3);

            $rootScope.debugInfo(reason.error);
            return false;
          });
      };

      $scope.checkLcn = function (asset) {
        if ($scope.IntLcn) $timeout.cancel($scope.IntLcn);

        $scope.IntLcn = $timeout(function () {

          AssetService.getChannelByLcn(asset.er_lcn)
            .then(function (collection) {
              asset._PrivateData.validateWarning = {};
              if (collection.length && !_.find(collection, {id: asset.id})) {
                asset._PrivateData.validateWarning.lcn = true;
                asset._PrivateData.validateWarning.lcnText = 'Already exist';
              }
            })
        }, 150);
      };

      $scope.manageLocalizations = function () {
        MetadataService.LocalizationManager($scope.asset, $scope);
      }
    }]);
